import { InputField } from "components/designV2/inputfield/inputfield";
import { useTranslation } from "react-i18next";
import { normalizeNumber } from "web-apps/company/components/common/number.normalize.logic";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const DeductionSetting: React.FC<{
  value: number;
  onChange: (v: number) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const deductionLabel = `${t("System.Deduction")} (kr)`;

  const handleChange = (nextValue: string): void => {
    const normalizedValue = normalizeNumber(nextValue);
    if (normalizedValue !== null) onChange(normalizedValue);
  };

  return (
    <SystemSettingRow
      title={deductionLabel}
      description={t("System.DeductionInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <InputField
            ariaLabel={deductionLabel}
            value={String(value)}
            type="number"
            size="compact"
            onChange={handleChange}
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
